import * as urls from '../constants/urls';

export const userPages = [urls.MY_PROFILE_URL, urls.LOG_OUT_URL];

export const profilePages = [
	urls.PROFILE_SETTINGS_URL,
	urls.CUSTOM_SETTINGS_URL,
	urls.PERMISSIONS_URL,
	urls.ACTIVITY_LOG_URL,
];

export const profileRestricted = [urls.PROFILE_SETTINGS_URL, urls.CUSTOM_SETTINGS_URL];

export const adminPages = [urls.BACKOFFICE_USERS_URL, urls.ACTIVITY_LOG_URL];

export const playerPages = [urls.PLAYER_LIST_URL, urls.PLAYER_SESSIONS_URL, urls.PLAYER_TRANSACTIONS_URL];
export const gamesPages = [urls.GAMES_URL, urls.GAME_PROVIDERS_URL, urls.GAME_CATEGORIES_URL, urls.GAME_PARTNERS_URL];

export const bonusPages = [urls.PROMOTIONAL_MONEY_DROP_URL, urls.PROMOTIONAL_FREE_SPINS_URL];
export const reportsPages = [
	urls.REPORTS_GAMBLING_REPORT_URL,
	urls.REPORTS_PARTNERS_REPORT_URL,
	urls.REPORTS_GAMES_REPORT_URL,
];

export const mainNavPages = [
	urls.DASHBOARD_URL,
	// {
	// 	label: 'Players',
	// 	options: [urls.PLAYER_LIST_URL, urls.PLAYER_SESSIONS_URL, urls.PLAYER_TRANSACTIONS_URL],
	// },
	// {
	// 	label: 'Reports',
	// 	options: [urls.REPORTS_GAMBLING_REPORT_URL],
	// },
	{
		label: 'Admin Panel',
		options: adminPages,
	},
];

export const superAdminNavPages = [
	urls.DASHBOARD_URL,
	{
		label: 'Players',
		options: [urls.PLAYER_LIST_URL, urls.PLAYER_SESSIONS_URL, urls.PLAYER_TRANSACTIONS_URL],
	},
	{
		label: 'Reports',
		options: [urls.REPORTS_GAMBLING_REPORT_URL, urls.REPORTS_PARTNERS_REPORT_URL, urls.REPORTS_GAMES_REPORT_URL],
	},
	{
		label: 'Promotional Tools',
		options: [urls.PROMOTIONAL_MONEY_DROP_URL, urls.PROMOTIONAL_FREE_SPINS_URL],
	},
	{
		label: 'Games',
		options: gamesPages,
	},
	{
		label: 'Admin Panel',
		options: adminPages,
	},
];

export const mainNavRestricted = [
	urls.DASHBOARD_URL,
	{
		label: 'Players',
		options: [urls.PLAYER_LIST_URL, urls.PLAYER_SESSIONS_URL, urls.PLAYER_TRANSACTIONS_URL],
	},
	{
		label: 'Reports',
		options: [urls.REPORTS_GAMBLING_REPORT_URL, urls.REPORTS_PARTNERS_REPORT_URL, urls.REPORTS_GAMES_REPORT_URL],
	},
];

export const fullPlayersNavigation = [
	urls.DASHBOARD_URL,
	{
		label: 'Players',
		options: [urls.PLAYER_LIST_URL, urls.PLAYER_SESSIONS_URL, urls.PLAYER_TRANSACTIONS_URL],
	},
];

export const fullFinancialNavigation = [
	urls.DASHBOARD_URL,
	{
		label: 'Reports',
		options: [urls.REPORTS_GAMBLING_REPORT_URL, urls.REPORTS_PARTNERS_REPORT_URL, urls.REPORTS_GAMES_REPORT_URL],
	},
];
